<template>
  <div
    v-if="shareChannels"
    class="relative px-3"
    :class="$style.footer"
  >
    <div
      class="inline-flex justify-between w-full text-sm text-right"
      :class="$style['bar']"
    >
      <div>
        <XExpressions
          v-if="attendeeId && showExpressions"
          :value="expressions"
          :reactionId="reaction.id"
        />
      </div>

      <XShareContent
        v-if="showShare"
        :reactionId="reaction.id"
        :showUrl="reaction.showUrl"
        :downloadUrl="reaction.downloadUrl"
        :shareChannels="shareChannels"
        :shareMessage="shareMessage"
        :shareHashtags="shareHashtags"
        :shareDescription="shareDescription"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import XExpressions from './Expressions'
import XShareContent from './ShareContent'

export default {
  components: {
    XExpressions,
    XShareContent
  },

  props: {
    reaction: {
      type: Object
    },
    shareChannels: {
      type: Array
    },
    shareMessage: {
      type: String
    },
    shareHashtags: {
      type: Array
    },
    shareDescription: {
      type: String
    },
    showShare: {
      type: Boolean
    },
    showExpressions: {
      type: Boolean
    }
  },

  computed: {
    ...mapState({
      attendeeId: state => state.routeParameters.attendee ? state.routeParameters.attendee.id : null
    }),

    expressions () {
      return this.reaction.interactions && this.reaction.interactions.length > 0
        ? this.reaction.interactions.find(interaction => interaction.type === 'expression')
        : {}
    }
  }
}
</script>

<style module>
.footer {
  height: 40px;
}

.bar {
  min-height: 25px;
}
</style>
